/**
 * @whatItDoes This service exposes the current user's authentication data
 *
 * TODO: Refactor out and delete or refactor AuthDataService to remove duplicate functionality
 */
import { Injectable } from '@angular/core';
import moment from 'moment';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { AuthData } from '../../models';
import { AuthDataService } from '../auth-data';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {
  constructor(private authDataService: AuthDataService) {}

  /**
   * Returns the authenticated user's AuthData from the cache if it exists
   */
  getAuthToken(): string {
    if (isNullOrUndefined(this.authDataService.currentUserAuthData)) {
      return null;
    }

    return this.authDataService.currentUserAuthData.token;
  }

  isAuthTokenExpired(): boolean {
    const currentUserAuthData: AuthData = this.authDataService.currentUserAuthData;
    if (isNullOrUndefined(currentUserAuthData)) {
      return true;
    }

    if (isNullOrUndefined(currentUserAuthData.expires)) {
      return true;
    }

    return moment().isAfter(moment(currentUserAuthData.expires));
  }
}
